// Web and mobile Work text is one point larger than the compact Mac type scale.
export function workMarkdownStyles(shared, isWeb) {
  const type = { fontSize: 15, lineHeight: isWeb ? '1.5' : 22.5 };
  const styles = { ...shared };
  for (const key of ['body', 'text', 'selectableText', 'paragraph']) {
    styles[key] = { ...shared[key], ...type };
  }
  for (const key of ['bullet_list_icon', 'ordered_list_icon']) {
    styles[key] = { ...shared[key], fontSize: type.fontSize, lineHeight: 22.5 };
  }
  if (isWeb) styles.list_item = { ...shared.list_item, ...type };
  styles.code_inline = { ...shared.code_inline, fontSize: 14 };
  const sizes = [22, 19, 16, 15, 14, 14];
  const heights = [29, 26, 23, 22, 21, 21];
  sizes.forEach((fontSize, index) => {
    const key = `heading${index + 1}`;
    styles[key] = {
      ...shared[key], fontSize: fontSize + 1,
      lineHeight: isWeb ? `${heights[index] + 1.5}px` : heights[index] + 1.5,
    };
  });
  return styles;
}
